import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { Link } from "react-router-dom";

export const ServicesSection = () => {
  const { t } = useLanguage();
  let cards = t("services.cards");
  if (!Array.isArray(cards)) {
    const s = t("services");
    cards = s && Array.isArray(s.cards) ? s.cards : [];
  }

  return (
    <section id="services" className="section-padding bg-white dark:bg-[#0b1318] transition-colors duration-300">
      <div className="container-width">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-10"
        >
          <span className="text-[#5cb85c] font-semibold text-sm tracking-wider mb-3 block">
            {t("services.sectionTag")}
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-slate-900 dark:text-white mb-4 transition-colors">
            {t("services.title")}
          </h2>

          <p className="text-lg text-slate-600 dark:text-slate-300 transition-colors">
            {t("services.subtitle")}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-3 gap-4 md:gap-6 mb-8"
        >
          {cards.map((c, i) => (
            <div key={i} className="rounded-2xl border border-slate-200 dark:border-white/10 p-6 bg-slate-50 dark:bg-white/5 transition-colors">
              <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">{c.title}</h3>
              <p className="text-slate-600 dark:text-slate-300 text-sm">{c.text}</p>
            </div>
          ))}
        </motion.div>

        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/service-de-reemaillage"
            className="inline-flex min-h-11 items-center rounded-2xl border border-slate-300 px-5 py-3 font-semibold text-slate-800 transition hover:bg-slate-50 dark:border-white/20 dark:text-white dark:hover:bg-white/10"
          >
            {t("services.learnMore")}
          </Link>
          <a
            href="/#contact"
            className="inline-flex items-center rounded-2xl bg-[#66C95E] px-6 py-3.5 text-base font-semibold text-white shadow-sm transition hover:bg-[#58B551]"
          >
            {t("services.cta")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
